import React from 'react';
import * as S from './SeoSRPTopContent.styles';

const SeoSRPTopContent: React.FC<{
  ContainerWrapper: Element;
  topContent;
}> = ({ContainerWrapper, topContent}) => {
  const {title = '', description = ''} = topContent ? topContent : {};

  const gethtml = () => {
    return (
      <S.SeoSrpTopContentBlockContainerWrap>
        <S.SeoSrpTopContentBlockTextWrap>
          <S.SeoSrpTopContentHeader>{title}</S.SeoSrpTopContentHeader>
          <S.SeoSrpTopContentCasesInfoText color="black">
            {description}
          </S.SeoSrpTopContentCasesInfoText>
        </S.SeoSrpTopContentBlockTextWrap>
      </S.SeoSrpTopContentBlockContainerWrap>
    );
  };

  if (topContent && title && description)
    return ContainerWrapper && <ContainerWrapper>{gethtml()}</ContainerWrapper>;
  return null;
};

export default SeoSRPTopContent;
